import {Component, Input} from '@angular/core';
import {Icon, Icons} from '../../../model/icon';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  standalone: true,
  styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() icon: Icon = Icons.default;
  @Input() width?: number;
  @Input() height?: number;
  @Input() invert?: number = 0;

  getSize() {
    return this.width && this.height ? `width: ${this.width}px; height: ${this.height}px;` : '';
  }
}
